import { render, staticRenderFns } from "./DataIcon.vue?vue&type=template&id=4e60546d&scoped=true"
import script from "./DataIcon.vue?vue&type=script&lang=js"
export * from "./DataIcon.vue?vue&type=script&lang=js"
import style0 from "./DataIcon.vue?vue&type=style&index=0&id=4e60546d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e60546d",
  null
  
)

export default component.exports